import React from 'react';

const isSandbox = window.location.hostname.includes("sandbox");

const MetaTags = () => (
  <>
    {isSandbox ? <meta name="robots" content="noindex, nofollow" /> : <meta name="robots" content="index, follow" />}
  </>
);

export default MetaTags;